<template>
    <div class="tabBar">
        <div class="tabBarCon">
            <div :class="`#${currenId}` == item.key ? 'tabItem-act' : ''" v-for="(item, index) in navList" :key="index"
                class="tabItem">
                <a :href="item.key">
                    {{ item.name }}
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        navList: {
            type: Array,
            default: (() => [])
        },
        currenId: {
            type: String,
            default: '',
        }
    },
    data() {
        return {

        }
    },
    created() {

    },
    methods: {

    },
}
</script>

<style lang="scss" scoped>
.tabBar {
    border-bottom: 1px solid #000000;
    margin-bottom: calc(116px - 57px);
    position: sticky;
    top: 0px;
    left: 0px;
    background-color: #ffffff;
    z-index: 9;

    .tabBarCon {
        width: 1200px;
        margin: auto;
        display: flex;
        align-items: center;

        .tabItem {
            margin-right: 100px;
            line-height: 55px;
            cursor: pointer;

            a {
                font-weight: 300;
                font-size: 18px;
                color: #000000;
                text-decoration: none;
            }
        }

        .tabItem-act {
            a {
                font-weight: bold;
            }
        }
    }

}

@media screen and (max-width:1200px) {
    .tabBar {
        border-bottom: 1px solid #000000;
        margin-top: 100px;

        .tabBarCon {
            width: 100%;
            box-sizing: border-box;
            margin: auto;
            display: flex;
            align-items: center;
            overflow: auto;

            .tabItem {
                margin-right: 30px;
                line-height: 60px;
                cursor: pointer;
                flex-shrink: 0;


                a {
                    font-weight: 300;
                    font-size: 16px;
                    color: #000000;
                    text-decoration: none;
                }
            }
        }

    }
}
</style>